import './Giftcard.css'
import { FC, useContext } from "react"
import { Flex } from 'antd'
import { ResponsiveContext } from '../../context/responsive-context'
import { TransparentButton } from '../../common-components/CustomButtons'

export const Giftcard: FC = () => {
  const { useVertical } = useContext(ResponsiveContext)
  return (
    <>
    { !useVertical &&
    <Flex className="Giftcard-container" justify={'space-evenly'}>
    <Flex vertical align={'center'} justify={'space-evenly'} style={{ height: '100%', width: '50%'}}>
        <h1 className="Giftcard-header" style={{ color: 'black'  }}>Ajándékba adnád a tanácsadást?</h1>
      <div className="Giftcard-body">Semmi akadálya! Kattints az Ajándékozok gombra, és megbeszéljük a részleteket!</div>
              <TransparentButton
              href='#book'
              >
                {"AJÁNDÉKOZOK"}
              </TransparentButton>
    </Flex>
    <Flex style={{height: '100%', width: '50%' }}>
      <div className="Giftcard-picture-container" style={{
        backgroundColor: 'white',
        backgroundImage: 'url("https://storage.googleapis.com/simonadelstyle/giftcard.jpeg")',
        width: '100%',
        margin: 50,
        backgroundSize: 'cover'
      }}>
      </div>
    </Flex>
    </Flex>
    }
    { useVertical &&
    <Flex className="Giftcard-container-vertical" vertical >
      <Flex vertical justify={'start'} style={{height: '10vh'}}>
        <h1 className="Giftcard-header-vertical" style={{ color: 'black'  }}>Ajándékba adnád a tanácsadást?</h1>
      </Flex>
      <Flex vertical justify={'end'} style={{height: '20vh'}}>
      <div className="Giftcard-body-vertical">Semmi akadálya! Kattints az Ajándékozok gombra, és megbeszéljük a részleteket!</div>
      </Flex>
      <Flex vertical justify={'center'} align={'center'} style={{height: '70vh'}}>
              <TransparentButton
              href='#book'
              >
                {"AJÁNDÉKOZOK"}
              </TransparentButton>
      </Flex>
    </Flex>
    }
    </>
  )
}
